import { generatePath, useNavigate } from 'react-router'

import { usePrincipal } from '../../../application/authentication'
import { ExcessPath } from '../../../application/product/policy/excess/ExcessPath'
import { PolicyPath } from '../../../application/product/policy/PolicyPath'
import { usePolicy } from '../../../application/product/policy/PolicyProvider'
import { PolicyChangeType } from '../../../domain'
import { useApiErrorHandlingAsyncCallback } from '../../auth'
import { isVoluntaryExcess, useExcesses } from '../../excess'

export interface ExcessData {
  excess: number
  excessCode: string
}

export const usePolicyExcessAdjustment = (onComplete?: () => void) => {
  const navigate = useNavigate()

  const { apiClient } = usePrincipal()
  const { policy } = usePolicy()

  const { quote } = policy.currentPolicyVersion
  const { voluntary } = useExcesses(quote)

  return useApiErrorHandlingAsyncCallback(
    async (data: ExcessData, effectiveAt?: string) => {
      const voluntaryExcess = voluntary.find(isVoluntaryExcess(data.excessCode))

      if (voluntaryExcess?.excess !== data.excess) {
        const { adjustmentId } = await apiClient.createPolicyAdjustment({
          policyId: policy.policyId,
          adjustmentType: 'MTA',
          changes: [
            {
              changeType: PolicyChangeType.SELECT_VOLUNTARY_EXCESS,
              ...data,
            },
          ],
          ...(effectiveAt && { effectiveAt }),
        })
        navigate(
          generatePath([PolicyPath.EXCESS, ExcessPath.REVIEW].join('/'), {
            adjustmentId,
          }),
        )
      }

      onComplete?.()
    },
  )
}
